export default {
	zhifujieguoyanzhengzhong: '支付結果正在査詢中，請您稍後再試。',
	zhengzaiweininchaxun: '正在為您査詢，感謝您的耐心等待',
	qingshuruhuoxuanzenidechengshi: '請輸入或選擇您的目的地',
	qingshuruchufadidian: '請輸入出發地點!',
	qingshurumudidi: '請輸入目的地!',
	qinglijiyuwomenlianxin: '請立即與我們聯系，以獲得任何査詢或預訂幫助。',
	lijiyuwomenliaotian: '立即與我們聊天',
	kehufuwurexian: '客戶服務熱線',
	xuyaobangzhuma: '需要幫助嗎？',
	geiwomenfadianziyoujian: '給我們發電子郵件',
	chaxunbiaoge: '聯繫表',
	songxinren: 'Messenger',
	xingming: '姓名',
	gongsimingcheng: '公司名稱',
	youjiandizhi: '電子郵寄地址',
	lianxidianhua: '聯繫電話',
	zhuti: '主題',
	liuyan: '留言',
	tijiao: '提交',
	lianxiwomen: '聯繫我們',
	shouyetishixinxi: '*以上價格僅適用於經濟艙的回程班機。 實際價格可能有所不同。 適用條款和條件。',
	shangyiye: '上一頁',
	xiayiye: '下一頁',
	fangda: '放大',
	suoxiao: '缩小',
	shengdantishi: '提交訂單失敗，返回搜索結果頁重新搜索',
	qushouye: '去首頁',
	hangbanyishouqing: '班機已售罄',
	zhifushibai: '支付失敗',
	zhifuchaoshi: '支付超時',
	chongxinzhifu: '重新支付',
	yudingshibai: '預定失敗',
	dingdanzhengzaichulizhong: '訂單正在處理中，請稍後重繪查看狀態！',
	yiwancheng: '已完成',
	zhifufangshi: '支付方式',
};
